import { combineReducers } from 'redux';
import shareReducers from 'js/Reducers/index.reducers';
import {steps} from './Reducers/Steps.reducer';


export const AppReducers = combineReducers({
    ...shareReducers,
    steps
});